module.exports = __webpack_public_path__ + "img/email.b600dd1f.png";